import commonApps from '../common/apps'

export default [...commonApps]
